import { Component, Inject } from '@angular/core';
import { DialogData } from '../dialog.models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-dialog-confirm',
	templateUrl: './dialog-confirm.component.html',
	styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
		public dialogRef: MatDialogRef<DialogConfirmComponent>
	) {}
}
